
import React from "react";
import { Schemes } from "../../../../utils";
import { i18nManager } from "../../../../i18n";
import { Elements } from "../../../shared/Elements";
import { Siren } from "../../../shared/ConfirmDialog";
import { Button, Checkbox, Form } from "@rivtn/noseur";
import LoadingGif from "../../../../assets/images/loading_circle.gif";
import { BaseService, IMember, IProfileWebsite, MemberService, SanitizedResponse } from "../../../../services";

export interface ScheduleProps {
    profile: IMember;
}

function Schedule(_: ScheduleProps) {

    const memberService = MemberService.getInstance();
    const labels = i18nManager.Labels.account.profile_website.schedule;
    const [profileWebsite, setProfileWebsite] = React.useState<IProfileWebsite>();

    React.useEffect(() => {
        memberService.getProfileWebsite().then(({ sanitized }: SanitizedResponse<IProfileWebsite>) => {
            setProfileWebsite(sanitized);
        }).catch(BaseService.reportError);
    }, []);

    return (<div className="account-setting">
        <div className="header">
            <span className="title">{i18nManager.Labels.account.profile_website.title} - {labels.title}</span>
        </div>
        {!profileWebsite
            ? (<div style={{ margin: "90px 110px" }}>
                <img alt={"loading"} src={LoadingGif} style={{ width: 80, margin: "auto" }} />
            </div>)
            : (<Form scheme={Schemes.OMNEHOST} className="profile-settings">
                <Checkbox label={labels.enable_ad} defaultChecked={profileWebsite?.schedule_settings?.enable_rivtn_ad} onChange={(e: any) => {
                    setProfileWebsite({ ...profileWebsite, schedule_settings: { ...profileWebsite.schedule_settings, enable_rivtn_ad: e.checked } })
                }} />
                <hr />
                <Checkbox label={labels.show_personal_past_matches} defaultChecked={profileWebsite?.schedule_settings?.show_past_personal_matches} onChange={(e: any) => {
                    setProfileWebsite({ ...profileWebsite, schedule_settings: { ...profileWebsite.schedule_settings, show_past_personal_matches: e.checked } })
                }} />
                <Checkbox label={labels.show_personal_ongoing_and_upcoming_matches} defaultChecked={profileWebsite?.schedule_settings?.show_ongoing_upcoming_personal_matches} onChange={(e: any) => {
                    setProfileWebsite({ ...profileWebsite, schedule_settings: { ...profileWebsite.schedule_settings, show_ongoing_upcoming_personal_matches: e.checked } })
                }} />
                <Checkbox label={labels.show_team_past_matches} defaultChecked={profileWebsite?.schedule_settings?.show_past_team_matches} onChange={(e: any) => {
                    setProfileWebsite({ ...profileWebsite, schedule_settings: { ...profileWebsite.schedule_settings, show_past_team_matches: e.checked } })
                }} />
                <Checkbox label={labels.show_team_ongoing_and_upcoming_matches} defaultChecked={profileWebsite?.schedule_settings?.show_ongoing_upcoming_team_matches} onChange={(e: any) => {
                    setProfileWebsite({ ...profileWebsite, schedule_settings: { ...profileWebsite.schedule_settings, show_ongoing_upcoming_team_matches: e.checked } })
                }} />
                <Button scheme={Schemes.OMNEHOST} text={i18nManager.Labels.common.save_changes} loadingProps={Elements.BUTTON_LOADING_PROPS}
                    style={{ marginTop: 20 }} onClick={(e) => {
                        e.manageRef?.setLoadingState(true);
                        updateProfileWebsite(() => e.manageRef?.setLoadingState(false));
                    }} />
            </Form>)}
    </div>);

    function updateProfileWebsite(onDone?: () => void) {
        memberService.updateProfileWebsite(profileWebsite!).then(({ sanitized }: SanitizedResponse<IProfileWebsite>) => {
            setProfileWebsite(sanitized);
            Siren.alert(i18nManager.Labels.account.profile_website.update_successful);
        }).catch(BaseService.reportError).finally(onDone);
    }

}

export default Schedule;
